'use strict';

const $ = jQuery.noConflict();
import '@fancyapps/fancybox';

$(function() {

	const cardAlbumSong = {

		init: function() {
			this.bindEvents();
			this.initPopups();
		},

		bindEvents: function() {
			// re-init fancybox after ajax change
			$(document).on('media-listing:updated', function() {
				$.fancybox.destroy();
				cardAlbumSong.initPopups();
			});
		},

		getEmbedUrl: function(url) {
			let videoId = '';
			const patterns = [
				/youtu\.be\/([a-zA-Z0-9_-]+)/,
				/[?&]v=([a-zA-Z0-9_-]+)/,
				/\/embed\/([a-zA-Z0-9_-]+)/,
				/\/shorts\/([a-zA-Z0-9_-]+)/,
			];

			for (const pattern of patterns) {
				const match = url.match(pattern);
				if (match) {
					videoId = match[1];
					break;
				}
			}

			if (videoId) {
				return 'https://www.youtube.com/embed/' + videoId + '?enablejsapi=1&rel=0&modestbranding=1&controls=1&playsinline=1';
			}

			return url;
		},

		initPopups: function() {
			// Initialize Fancybox for each popup trigger
			$('.js-popup-trigger').each(function() {
				const $trigger = $(this);
				const $card = $trigger.closest('.js-card-video-play');
				const $popup = $card.find('.js-popup');

				$trigger.on('click', function(e) {
					e.preventDefault();

					$.fancybox.open({
						src: $popup,
						type: 'inline',
						smallBtn: true,
						baseClass: 'popup-custom-class',
						beforeShow: () => {
							const $iframe = $popup.find('.js-popup-video-iframe');
							const videoSrc = $iframe.attr('data-src');

							if (videoSrc && !$iframe.attr('src')) {
								$iframe.attr('src', cardAlbumSong.getEmbedUrl(videoSrc));
							}
						}
					});
				});
			});
		}

	};

	// Initialize if cards exist on page
	if ($('.js-card-video-play').length) {
		cardAlbumSong.init();
	}


	const cardQuote = {

		init: function() {
			this.bindEvents();
		},

		bindEvents: function() {
			$(document).on('click', '.card__action-btn--share', this.toggleShare);
			$(document).on('click', this.closeShare);

			// custom event listener
			$(document).on('media-listing:updated', function() {
				if (typeof window.a2a !== 'undefined') {
					window.a2a.init_all();
				}
			});
		},

		toggleShare: function(e) {
			e.stopPropagation();
			const $btn = $(this);
			const wasOpen = $btn.hasClass('is-share-open');

			// Close all other open share buttons
			$('.card__action-btn--share.is-share-open').removeClass('is-share-open');

			if (!wasOpen) {
				$btn.addClass('is-share-open');
			}
		},

		closeShare: function(e) {
			// If click is on a share link, let it work
			if ($(e.target).closest('.addtoany_list a').length) {
				return;
			}

			$('.card__action-btn--share.is-share-open').removeClass('is-share-open');
		},

	};

	if ($('.card__action-btn--share').length) {
		cardQuote.init();
	}

});